import { api } from "../../../utils/api";

export async function patchLeadStatus(data) {
  try {
    const response = await api.patch('/lead', data);
    return response.data;
  } catch (error) {
    throw error;
  }
}